import { PlayerProfileContext } from '@library/components/player/PlayerProfile';
import playerPlaceholder from '@library/assets/images/icons/player-placeholder.svg';
import { useContext } from 'react';

export interface PlayerImageProps {
  className?: string;
}

export const PlayerImage = ({ className = undefined }: PlayerImageProps) => {
  const { imageUrl, name } = useContext(PlayerProfileContext);

  return (
    <img
      className={className ?? 'hidden w-fit placeholder:h-14 2xl:grid'}
      src={imageUrl}
      alt={`${name} headshot}`}
      onError={(e) => {
        e.currentTarget.src = playerPlaceholder;
      }}
    />
  );
};
